import React from 'react';
import PropTypes from 'prop-types';
import clock from '../../../../assets/images/icons/clock-dark.svg';
import calender from '../../../../assets/images/icons/calender.svg';
import './LengthOfEngagement.scss';

const imgTag = (icon, altText) => (
  <img className="me-2 mb-1" src={icon} alt={`${altText}`} />
);

function LengthOfEngagement({
  duration,
  showEditLink,
  renderEditLink,
  avgTimeRequiredRange,
}) {
  return (
    <div className="length-of-engagement-container">
      <div className="header-container">
        <span className="title">Length of Engagement</span>
        {showEditLink && renderEditLink()}
      </div>
      <div className="length-of-engagement-body mt-3">
        <div className="d-flex align-items-baseline">
          <span className="mb-3">{imgTag(clock, 'clock-icon')}</span>
          {!duration || duration === 'not sure' ? 'Duration' : `${duration} months duration`}
        </div>
        <div className="d-flex align-items-baseline">
          <span className="mb-3">{imgTag(calender, 'calender-icon')}</span>
          {!avgTimeRequiredRange || avgTimeRequiredRange === 'not sure' ? 'Hours' : `${avgTimeRequiredRange} hours per week`}
        </div>
      </div>
    </div>
  );
}

LengthOfEngagement.propTypes = {
  showEditLink: PropTypes.bool,
  renderEditLink: PropTypes.func,
  duration: PropTypes.number.isRequired,
  avgTimeRequiredRange: PropTypes.number.isRequired,
};

LengthOfEngagement.defaultProps = {
  renderEditLink: () => {},
  showEditLink: false,
};

export default LengthOfEngagement;
